var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-management"},[_c('router-view',{staticClass:"router-user-management-top-section",attrs:{"name":"top-section"}}),_c('router-view',{staticClass:"router-user-management-main"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }